var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPlaceholderLogo = function SvgPlaceholderLogo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12498_1575)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#F1F0F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7027 15.6946C34.1467 12.2133 26.3333 12.0986 24 16.5493C21.6667 12.104 13.852 12.2186 11.2973 15.6946C9.99467 17.468 10.5053 19.6093 12.5653 21.0106L23.6293 28.8693C23.7375 28.9464 23.8671 28.9879 24 28.9879C24.1329 28.9879 24.2625 28.9464 24.3707 28.8693L35.4347 21.0106C37.4947 19.6146 38.004 17.4733 36.7027 15.6946Z",
    stroke: "#6A6D74",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4173 17.604V22.832C37.4175 23.6481 37.2222 24.4523 36.8478 25.1775C36.4734 25.9026 35.9308 26.5276 35.2653 27L24.3707 34.7333C24.2626 34.8102 24.1333 34.8514 24.0007 34.8514C23.8681 34.8514 23.7387 34.8102 23.6307 34.7333L12.7347 26.9987C12.0695 26.5261 11.5271 25.9011 11.153 25.1759C10.7788 24.4508 10.5837 23.6466 10.584 22.8307V17.604",
    stroke: "#6A6D74",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 46,
    height: 46,
    stroke: "#F1F0F2",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12498_1575"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPlaceholderLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "placeholder-logo.4baa572e49805f592408550891930251.svg";